import { Component, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LayoutStore } from "@/app/core/state/layout.store";

/**
 * Forbidden page component displayed when access is denied.
 * It injects the LayoutStore to ensure the theme is applied.
 */
@Component({
  selector: "app-forbidden",
  imports: [TranslateModule],
  templateUrl: "./forbidden.component.html",
})
export class ForbiddenComponent {
  constructor() {
    inject(LayoutStore); // Needed to apply theme
  }
}
